<template>
  <div class="index-box">
    <div class="index-item">
      <h3>通知公告 <a href="/h5/noticeList">更多</a></h3>
      <a v-for="item in list" :key="item.noticeId" :href="'/content/noticeDetail?id='+item.noticeId" class="notice-item">
        <div>
          <h2 class="ovDna">{{item.title}}</h2>
          <p>{{item.createTime}}</p>
        </div>
        <i class="iconfont iconxiayibu "></i>
      </a>
    </div>
    <div class="index-item">
      <h3>关于入会</h3>
      <div class="about-box">
        <a href="/content/indexDetail?id=1&name=入会">
          <img src="../../assets/img/icon1.png" alt="">
          <p>入会</p>
        </a>
        <a href="/content/indexDetail?id=2&name=退会">
          <img src="../../assets/img/icon4.png" alt="">
          <p>退会</p>
        </a>
        <a href="/content/indexDetail?id=3&name=会员章程" style="width: 30%">
          <img src="../../assets/img/icon3.png" alt="">
          <p>会员章程</p>
        </a>

      </div>
    </div>
<!--    <div class="index-item">-->
<!--      <h3>会员制度</h3>-->
<!--      <div class="zhidu">-->
<!--        <a href="/content/indexDetail?id=5&name=会员管理制度"><i class="iconfont iconguanlizhidu"></i>会员管理制度</a>-->
<!--        <a href="/content/indexDetail?id=6&name=会员奖励与处分"><i class="iconfont iconjiangli"></i>会员奖励与处分</a>-->
<!--        <a href="/content/indexDetail?id=7&name=会员红名单规定"><i class="iconfont iconziyuan"></i>会员红名单规定</a>-->
<!--        <a href="/content/indexDetail?id=8&name=会员黑名单规定"><i class="iconfont iconArtboard"></i>会员黑名单规定</a>-->
<!--      </div>-->
<!--    </div>-->
    <bottomNav :navIndex="navIndex"/>
  </div>
</template>

<script>
  import bottomNav from '../components/Nav'
  export default {
    name: "Index",
    data(){
      return {
        navIndex:0,
        list:[]
      }
    },created() {
      this.init()
    },
    methods:{
      init(){
        this.$api.apiContent.noticeList({
          token: this.$store.state.user.token,
          pageNume:1,
          pageSize:4
        }).then(res=>{
          res.row.map(item=>{
            item.createTime = this.$tools.ZHDate(new Date(item.createTime))
          })
          this.list = res.row
        })
      }
    },
    components:{
      bottomNav
    }
  }
</script>

<style scoped lang="scss">
.index-box{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  padding-bottom: 60px;
  background-image: url(../../assets/img/homebg.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  overflow-y: scroll;
  .index-item{
    margin: 10px 20px;
    padding: 15px;
    background-color: #ffffff;
    box-shadow: 0px 2px 8px 0px
    rgba(200, 200, 200, 0.5);
    border-radius: 5px;
    h3{
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 22px;
      line-height: 30px;
      color: #0c7cbc;
      margin-bottom: 10px;
      a{
        display: block;
        width: 46px;
        height: 21px;
        text-align: center;
        line-height: 21px;
        font-size: 14px;
        color: #0c7cbc;
        background-color: #e9f5ff;
        border-radius: 11px;
      }
    }
    a.notice-item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      padding: 5px 0;
      div{
        flex: 1;
        overflow: hidden;
        margin-right: 10px;
        h2{
          width: 100%;
          font-size: 20px;
          line-height: 28px;
          color: #333;
        }
        p{
          font-size: 14px;
          line-height: 24px;
          color: #999;
        }
      }
      i{
        font-size: 16px;
        color: #999;
      }
    }
    .about-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      a{
        display: block;
        width: 20%;
        padding: 10px 0;
        img{
          display: block;
          width: 40px;
          height: 40px;
          border-radius: 40px;
          margin: 0 auto 10px;
        }
        p{
          text-align: center;
          font-size: 16px;
          color: #333;
        }
      }
    }
    .zhidu{
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      a{
        display: flex;
        align-items: center;
        width: 48%;
        height: 50px;
        background-color: #e9f5ff;
        border-radius: 5px;
        border: solid 1px #c9e6ff;
        padding: 5px ;
        margin-bottom: 4%;
        font-size: 15px;
        color: #2b8ee3;
        i{
          font-size: 20px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>